import React from 'react';
import { IVolumeSlider } from '../SliderFactory';
import VolumeSlider from './SliderWithControlButton';

function SliderWithControlButtonSideLeft(
    others: IVolumeSlider
): React.ReactElement {
    return (
        <VolumeSlider
            thumbImgSrc={`/resources/speechComfort/slider-left.svg`}
            {...others}
        />
    );
}

export default SliderWithControlButtonSideLeft;
